// Shared reference data for the mass-update flows. `item` and `location` are
// genuine shared reference tables per HANDOVER.md's data model — Work Orders
// and Import Work Orders both validate against these. Search Sales Orders
// predates this file and keeps its own inline copy; not touching that one.

import type { EnumOption } from "@/lib/enums";

export interface ReferenceItem {
  code: string;
  description: string;
}

export interface ReferenceLocation {
  code: string;
  name: string;
}

export const REFERENCE_ITEMS: readonly ReferenceItem[] = [
  { code: "JPC-2.0-M", description: "JPC 2.0 Plate Carrier, Medium" },
  { code: "JPC-2.0-L", description: "JPC 2.0 Plate Carrier, Large" },
  { code: "AVS-BASE", description: "AVS Base Vest" },
  { code: "PC-CAGE-M", description: "Precision Cut Cage, Medium" },
  { code: "COMBAT-SHIRT-L", description: "Combat Shirt, Large" },
  { code: "G4-PANT-32", description: "G4 Field Pant, 32" },
];

export const ITEM_OPTIONS: readonly EnumOption[] = REFERENCE_ITEMS.map((item) => ({
  value: item.code,
  label: item.code,
}));

export const REFERENCE_LOCATIONS: readonly ReferenceLocation[] = [
  { code: "MAIN-WH", name: "Main Warehouse" },
  { code: "PROD-FL1", name: "Production Floor 1" },
  { code: "PROD-FL2", name: "Production Floor 2" },
  { code: "QC-HOLD", name: "QC Hold" },
];

export const LOCATION_OPTIONS: readonly EnumOption[] = REFERENCE_LOCATIONS.map((location) => ({
  value: location.code,
  label: location.name,
}));

export function findItem(code: string): ReferenceItem | undefined {
  return REFERENCE_ITEMS.find((item) => item.code.toLowerCase() === code.toLowerCase());
}

export function findLocation(code: string): ReferenceLocation | undefined {
  return REFERENCE_LOCATIONS.find((location) => location.code.toLowerCase() === code.toLowerCase());
}
